import { COMMON_QUERY_CONFIG } from '../shared/configs';

const QUERIES = {
  WSJ_AUDIO: 'wsj audio',
  WSJ_OPINION_AUDIO: 'WSJ Opinion Audio',
  WSJ: 'WSJ.com'
};

const COLUMN_NAMES = {
  OPINION_POTOMAC_WATCH: 'wsj opinion potomac watch',
  FREE_EXPRESSION: 'free expression'
};

export enum SECTION_ENUM {
  LATEST_EPISODES = 'latest-episodes',
  LATEST_NEWS = 'latest-news',
  LISTEN_TO_OPINION = 'listen-to-opinion',
  ALL_PODCASTS = 'all-podcasts'
}

const AUDIO_CONTENT_TYPE_FILTER = { term: { key: 'ContentType', value: 'audio' } };
const NOT_PODCAST_FACTIVA_FILTER = { term: { key: 'DocType', value: '77' } };

export const LATEST_EPISODES = {
  query: {
    and: [
      AUDIO_CONTENT_TYPE_FILTER,
      { term: { key: 'Product', value: QUERIES.WSJ_AUDIO } },
      { term: { key: 'Product', value: QUERIES.WSJ_OPINION_AUDIO } }
    ],
    not: [NOT_PODCAST_FACTIVA_FILTER]
  },
  ...COMMON_QUERY_CONFIG
};

export const LATEST_NEWS = {
  query: {
    and: [{ term: { key: 'TTSType', value: 'full' } }, { term: { key: 'Product', value: QUERIES.WSJ } }],
    not: [NOT_PODCAST_FACTIVA_FILTER]
  },
  ...COMMON_QUERY_CONFIG
};

export const LISTEN_TO_OPINION = {
  query: {
    and: [AUDIO_CONTENT_TYPE_FILTER, { term: { key: 'Product', value: QUERIES.WSJ_OPINION_AUDIO } }],
    or: [{ terms: { key: 'ColumnName', value: [COLUMN_NAMES.OPINION_POTOMAC_WATCH, COLUMN_NAMES.FREE_EXPRESSION] } }],
    not: [NOT_PODCAST_FACTIVA_FILTER]
  },
  ...COMMON_QUERY_CONFIG
};

export const ALL_PODCASTS = {
  query: {
    and: [AUDIO_CONTENT_TYPE_FILTER, { term: { key: 'Product', value: QUERIES.WSJ_AUDIO } }],
    not: [AUDIO_CONTENT_TYPE_FILTER, { term: { key: 'Product', value: QUERIES.WSJ_AUDIO } }]
  },
  ...COMMON_QUERY_CONFIG
};
